var FILE_END_LETTERS_LENGTH = 4;
var MATCH_FILE_EXTENSION = {
    docx: 'doc',
    pptx: 'ppt',
    jpeg: 'jpg'
};
var formatBytes = function (bytes) {
    var decimals = 2;
    if (bytes === 0) {
        return '0 Bytes';
    }
    var k = 1024;
    var sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "".concat(parseFloat((bytes / (Math.pow(k, i))).toFixed(decimals)), " ").concat(sizes[i]);
};
var getRightLeftFileName = function (name) {
    // need this method to split file name in two parts, in order to display the name like this "Filenameisitt...ong.jpg"
    // based on container width
    var fileNameParts = name.split('.');
    var _a = fileNameParts, _b = fileNameParts.length - 1, fileType = _a[_b];
    var splitIndex = name.length - (fileType.length + FILE_END_LETTERS_LENGTH);
    var leftText = name.slice(0, splitIndex);
    var rightText = name.slice(splitIndex);
    return { leftText: leftText, rightText: rightText, fileType: fileType };
};
var getFileIcon = function (fileType) {
    var existingTypes = [
        '7z', 'cat', 'css', 'csv', 'doc', 'eps', 'exe', 'gif', 'gz', 'ics', 'img',
        'jpg', 'm4v', 'mp3', 'mp4', 'pdf', 'png', 'pps', 'ppt', 'psd', 'rar', 'swf',
        'tar', 'tgz', 'tif', 'txt', 'vcf', 'wmf', 'wmv', 'xls', 'xml', 'zip'
    ];
    var iconCode = MATCH_FILE_EXTENSION[fileType] ||
        existingTypes.find(function (type) { return type === fileType; });
    return iconCode ? "icon-24-docs-".concat(iconCode, "-mono") : 'icon-24-document-mono';
};

export { formatBytes, getFileIcon, getRightLeftFileName };
//# sourceMappingURL=helper.js.map
